import api from "./api";

export const deleteException = async (id) => {
  return api
    .delete({
      endpoint: `/exception-time-booking/${id}`,
      port: process.env.REACT_APP_PORT_OPENHOUR,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
